import { useMemo } from 'react';
export const useReactChildProps = ({
  option,
  small,
  activeItem,
  isActiveIndex,
  childOfCategory
}) => {
  return useMemo(() => {
    let props = {
      small
    };
    if (option.type === 'OPTION') {
      props = {
        ...props,
        active: activeItem === option.id,
        hover: isActiveIndex,
        visibleCSSHover: false,
        childOfCategory
      };
    }
    return props;
  }, [activeItem, childOfCategory, isActiveIndex, option.id, option.type, small]);
};